import { http, HttpResponse, delay } from "msw";

const orders = [
    {
        "id": "5991675b-87df-4e9a-98ee-476ca55c2d09",
        "folio": "NAC-001",
        "customer": {
            "id": "bbfb85bb-315d-421d-bb4b-94cbf6953a79",
            "name": "Luis Aguilar",
            "email": "luis.aguilar.rocha@gmail.com"
        },
        "items": null,
        "assigned_user": {
            "id": null,
            "name": null
        },
        "order_type": "sale",
        "status": "canceled",
        "subtotal": "0.00",
        "tax": "0.00",
        "total": "0.00",
        "total_paid": "120.00",
        "created_at": "2026-01-10T09:16:42.920Z",
        "confirmed_at": null,
        "closed_at": null
    },
    {
        "id": "7194840d-5efe-486d-b93a-923f4569141e",
        "folio": "NAC-002",
        "customer": {
            "id": "bbfb85bb-315d-421d-bb4b-94cbf6953a79",
            "name": "Luis Aguilar",
            "email": "luis.aguilar.rocha@gmail.com"
        },
        "items": [
            {
                "id": "c31aaa07-a893-4bcf-b072-9145601290fc",
                "name": "Filtro de aceite FRAM PH3387A",
                "quantity": 2,
                "sale_price": 140
            }
        ],
        "assigned_user": {
            "id": null,
            "name": null
        },
        "order_type": "sale",
        "status": "draft",
        "subtotal": "0.00",
        "tax": "0.00",
        "total": "0.00",
        "total_paid": "0",
        "created_at": "2026-01-12T06:47:29.999Z",
        "confirmed_at": null,
        "closed_at": null
    },
    {
        "id": "fd36d1dd-0d8c-48cb-8b9a-0206da272362",
        "folio": "NAC-003",
        "customer": {
            "id": "bbfb85bb-315d-421d-bb4b-94cbf6953a79",
            "name": "Luis Aguilar",
            "email": "luis.aguilar.rocha@gmail.com"
        },
        "items": [
            {
                "id": "c31aaa07-a893-4bcf-b072-9145601290fc",
                "name": "Filtro de aceite FRAM PH3387A",
                "quantity": 2,
                "sale_price": 140
            }
        ],
        "assigned_user": {
            "id": null,
            "name": null
        },
        "order_type": "sale",
        "status": "canceled",
        "subtotal": "280.00",
        "tax": "4480.00",
        "total": "4760.00",
        "total_paid": "0",
        "created_at": "2026-01-12T07:08:59.399Z",
        "confirmed_at": null,
        "closed_at": null
    },
    {
        "id": "7669f0cb-2a52-4cd9-a6c7-0eb3665a755c",
        "folio": "NAC-004",
        "customer": {
            "id": "bbfb85bb-315d-421d-bb4b-94cbf6953a79",
            "name": "Luis Aguilar",
            "email": "luis.aguilar.rocha@gmail.com"
        },
        "items": [
            {
                "id": "c31aaa07-a893-4bcf-b072-9145601290fc",
                "name": "Filtro de aceite FRAM PH3387A",
                "quantity": 2,
                "sale_price": 140
            },
            {
                "id": "c31aaa07-a893-4bcf-b072-9145601290fc",
                "name": "Filtro de aceite FRAM PH3387A",
                "quantity": 2,
                "sale_price": 140
            },
            {
                "id": "c31aaa07-a893-4bcf-b072-9145601290fc",
                "name": "Filtro de aceite FRAM PH3387A",
                "quantity": 2,
                "sale_price": 140
            },
            {
                "id": "c31aaa07-a893-4bcf-b072-9145601290fc",
                "name": "Filtro de aceite FRAM PH3387A",
                "quantity": 2,
                "sale_price": 140
            }
        ],
        "assigned_user": {
            "id": null,
            "name": null
        },
        "order_type": "sale",
        "status": "closed",
        "subtotal": "280.00",
        "tax": "44.80",
        "total": "324.80",
        "total_paid": "324.80",
        "created_at": "2026-01-12T07:13:15.389Z",
        "confirmed_at": null,
        "closed_at": null
    }
];

const baseUrl = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_STAGE_ENV}/orders`

export const ordersHandlers = [
    http.get(`${baseUrl}`, async ({ request }) => {
        await delay(2100);

        return HttpResponse.json(
            orders,
            { status: 200 }
        );
    }),
    http.post(`${baseUrl}`, async ({ request }) => {
        const body = await request.json();

        if (body.appointment_id) {
            return HttpResponse.json(
                {
                    "id": "47463dc1-a1a2-4f06-a89c-02b138bc990a",
                    "folio": "NAC-035",
                    "customer": {
                        "id": "bbfb85bb-315d-421d-bb4b-94cbf6953a79",
                        "name": "Luis Aguilar",
                        "email": "luis.aguilar.rocha@gmail.com"
                    },
                    "items": null,
                    "assigned_user": {
                        "id": "5eced768-208c-4b3c-8676-6e6eee64ac05",
                        "name": "Marcela García"
                    },
                    "order_type": "service",
                    "status": "open",
                    "subtotal": "0.00",
                    "tax": "0.00",
                    "total": "0.00",
                    "total_paid": "0",
                    "created_at": "2026-02-03T08:22:35.492Z",
                    "confirmed_at": null,
                    "closed_at": null
                },
                { status: 201 }
            );
        }

        const newOrder = {
            "id": "fd36d1dd-0d8c-48cb-8b9a-0206da272362",
            "folio": `NAC-00${orders.length + 1}`,
            "customer": {
                "id": "bbfb85bb-315d-421d-bb4b-94cbf6953a79",
                "name": "Luis Aguilar",
                "email": "luis.aguilar.rocha@gmail.com"
            },
            "items": [
                {
                    "id": "c31aaa07-a893-4bcf-b072-9145601290fc",
                    "name": "Filtro de aceite FRAM PH3387A",
                    "quantity": 2,
                    "sale_price": 140
                }
            ],
            "assigned_user": {
                "id": null,
                "name": null
            },
            "order_type": "sale",
            "status": "canceled",
            "subtotal": "280.00",
            "tax": "4480.00",
            "total": "4760.00",
            "total_paid": "0",
            "created_at": "2026-01-12T07:08:59.399Z",
            "confirmed_at": null,
            "closed_at": null
        }
        orders.push(newOrder)

        await delay(800);

        return HttpResponse.json(
            newOrder,
            { status: 200 }
        );
    }),
    http.put(`${baseUrl}`, async ({ request }) => {
        const body = await request.json();
        let idx = orders.findIndex(item => item.id === body.id);
        orders[idx] = { ...body }
        await delay(800);

        return HttpResponse.json(
            orders.find(item => item.id === body.id),
            { status: 200 }
        );
    }),
    http.delete(`${baseUrl}/:id`, async ({ params }) => {
        const { id } = params;

        const index = orders.findIndex(c => c.id === id);

        if (index === -1) {
            return HttpResponse.json(
                { message: 'Item not found' },
                { status: 404 }
            );
        }

        const deletedOrder = orders[index];
        orders.splice(index, 1);

        await delay(800);

        return HttpResponse.json(
            deletedOrder,
            { status: 200 }
        );
    })
];
